export default __webpack_public_path__ + "3e4b4af40aa18069188175ace4c9dea6.svg";